/* Background-free original artwork: the original Shopify file remains unchanged.
 * SVG alpha filtering is the no-JavaScript fallback. Canvas additionally trims
 * empty padding after the CDN image loads, without redrawing any letter shapes.
 */
(() => {
  'use strict';
  const cache = new Map();
  async function transparentLogo(src) {
    if (cache.has(src)) return cache.get(src);
    const result = new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const scale = Math.min(1, 2000 / Math.max(image.naturalWidth, image.naturalHeight));
          const w = canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          const h = canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          const ctx = canvas.getContext('2d', {willReadFrequently:true});
          if (!ctx) throw new Error('Canvas is unavailable');
          ctx.drawImage(image, 0, 0, w, h);
          const frame = ctx.getImageData(0, 0, w, h);
          let left = w, top = h, right = -1, bottom = -1;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              const i = (y * w + x) * 4;
              const value = Math.max(frame.data[i], frame.data[i + 1], frame.data[i + 2]);
              const alpha = Math.max(0, Math.min(255, Math.round((value - 34) * 255 / 125)));
              frame.data[i] = 35; frame.data[i + 1] = 39; frame.data[i + 2] = 35;
              frame.data[i + 3] = Math.round(frame.data[i + 3] * alpha / 255);
              if (frame.data[i + 3] > 110) {
                left = Math.min(left,x); right = Math.max(right,x);
                top = Math.min(top,y); bottom = Math.max(bottom,y);
              }
            }
          }
          if (right < left || bottom < top) throw new Error('No logo artwork found');
          ctx.putImageData(frame, 0, 0);
          const pad = 4;
          left = Math.max(0,left-pad); top = Math.max(0,top-pad);
          right = Math.min(w-1,right+pad); bottom = Math.min(h-1,bottom+pad);
          const output = document.createElement('canvas');
          output.width = right-left+1; output.height = bottom-top+1;
          const outCtx = output.getContext('2d');
          if (!outCtx) throw new Error('Canvas is unavailable');
          outCtx.drawImage(canvas,left,top,output.width,output.height,0,0,output.width,output.height);
          resolve({src:output.toDataURL('image/png'),width:output.width,height:output.height});
        } catch (error) { reject(error); }
      };
      image.onerror = () => reject(new Error('Logo image could not be loaded'));
      image.src = src;
    });
    cache.set(src,result);
    return result;
  }
  function initialize(root) {
    root.querySelectorAll('[data-fs-logo]:not([data-fs-ready])').forEach(async (element) => {
      element.dataset.fsReady = 'true';
      try {
        const data = await transparentLogo(element.dataset.logoSrc);
        if (!element.isConnected) return;
        const image = document.createElement('img');
        image.src = data.src; image.alt = ''; image.width = data.width; image.height = data.height;
        image.setAttribute('aria-hidden','true');
        element.replaceChildren(image);
      } catch (_) { /* The inline SVG fallback still removes the black background. */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fs-header details[open]').forEach(details => {
      details.removeAttribute('open');
      const trigger = details.querySelector('summary');
      if (trigger) trigger.focus();
    });
  });
})();
